import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {IOrder, ReasonCodeSelections, TransactionSelections} from "../../services/sale.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {IDataPair} from "../../shared/models/data-pair.model";
import {TranslateService} from "@ngx-translate/core";
import {Subscription} from "rxjs";

@Component({
	selector: 'cancel-order-popup',
	templateUrl: './cancel-order-popup.component.html',
	styleUrls: ['./cancel-order-popup.component.scss'],
})
export class CancelOrderPopupComponent {
	public orderNumber:string;
	public reasonCodeControl: FormControl<IDataPair>;
	public reasonCodeTypes: IDataPair[] = [];
	private _subscriptions = new Subscription();
	
	
	constructor(
		private _dialogRef: MatDialogRef<CancelOrderPopupComponent>,
		private _translateService: TranslateService,
		
		@Inject(MAT_DIALOG_DATA) private _data:{
			order: IOrder
		},
	) {
		this.orderNumber = _data.order.orderId;
		this.reasonCodeControl = new FormControl();
		
		//Sets cancel reason code types and translation
		this._setReasonCodeTypes();
		this._subscriptions.add(this._translateService.onLangChange.subscribe((val) => {
			this._setReasonCodeTypes();
		}));
	}
	
	public closePopup(reasonCodeControl:IDataPair) {
		if (reasonCodeControl) {
			this._dialogRef.close(this.reasonCodeControl.value);
		} else {
			this._dialogRef.close();
		}
	}
	
	private _setReasonCodeTypes(): void {
		this.reasonCodeTypes = [{
			key: ReasonCodeSelections.wrongAddr,
			value: `1017 - ${this._translateService.instant('reasonCode.wrongAddr')}`,
		},
			{
				key: ReasonCodeSelections.wrongItems,
				value: `1018 - ${this._translateService.instant('reasonCode.wrongItems')}`
			},
			{
				key: ReasonCodeSelections.wrongPayment,
				value: `1019 - ${this._translateService.instant('reasonCode.wrongPayment')}`,
			},
			{
				key: ReasonCodeSelections.changedMind,
				value: `1020 - ${this._translateService.instant('reasonCode.changedMind')}`
			},
			{
				key: ReasonCodeSelections.foundAlternative,
				value: `1021 - ${this._translateService.instant('reasonCode.foundAlternative')}`
			},
			{
				key: ReasonCodeSelections.mistake,
				value: `1022 - ${this._translateService.instant('reasonCode.mistake')}`
			},
			{
				key: ReasonCodeSelections.other,
				value: `1023 - ${this._translateService.instant('reasonCode.other')}`
			}];
	}
}
